<script lang="ts">
  import { ControlFrameHost } from "@kontextwerk/control-web-frame"
  import InternalAssistMount from "@kontextwerk/control-web-frame/shared/modules/internal-assist-mount"
  import { NO_PERMISSIONS } from "@kontextwerk/control-web-frame/shared/logic/authorization"
  import { controlContext } from "@kontextwerk/control-web-frame/shared/logic/authentication"
  import { derived } from "svelte/store"
  import { location } from "../../_shared/_logic/store"
  import { controlFrameConfig } from "./frameConfig"
  import { shouldShowInternalAssistForPath } from "./_logic/internalAssistVisibility"
  import { setKehrblattControlAuthContext } from "../_shared/_logic/auth-context"
  import CustomerImportStatusBannerMount from "./_modules/customer-import-status-banner-mount"

  // The frame root owns login and context selection; KB only projects the confirmed context.
  setKehrblattControlAuthContext(
    derived(controlContext, ($context) => ({
      session: $context?.session ?? null,
      user: $context?.actor ?? null,
      permissions: $context?.permissions ?? NO_PERMISSIONS,
      currentUserId: $context?.memberUserId ?? null,
      currentMembershipId:
        $context?.session?.context.kind === "organization"
          ? $context.session.context.membership_id
          : null,
      currentUserOrganizationId: $context?.organizationId ?? null,
    })),
  )

  const organizationContext = $derived(Boolean($controlContext?.organizationId))
  const showInternalAssist = $derived(
    organizationContext && shouldShowInternalAssistForPath($location.path),
  )
</script>

<ControlFrameHost config={controlFrameConfig} />
{#if showInternalAssist}
  <InternalAssistMount />
{/if}
{#if organizationContext}
  <CustomerImportStatusBannerMount />
{/if}
